import { lockoutWarning } from "../../constants/ImageConstants";
import FXCMErrorHandling from "../../components/common/FXCMErrorHandling";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import './Pagenotfound.scss';
import FXCMTrans from "../../components/common/FXCMTrans";

const PageNotFound = () => {
	const { t: getLabel } = useTranslation();


	return (
		<div className="error_Container" data-testid="page_id">
			<FXCMErrorHandling
				titleCondition={true}
				title={getLabel("PAGE_NOT_FOUND_TITLE")}
				subTitleCondition={true}
				image={lockoutWarning}
				imgWidth={25}
				imgHeight={25}
				column={false}
				PaddingTop={true}
			/>
			<Typography data-testid="page_subtitle" className="Sub-title" style={{ textAlign: "center", position: "relative", top: "-20px", fontSize: "13px" }}>
				<FXCMTrans defaults={getLabel("PAGE_NOT_FOUND_SUBTITLE")} />
			</Typography>
		</div>
	);
};

export default PageNotFound;








